import * as React from 'react'

interface Props {
  className?: string
  label: string
}

export const Label: React.FC<Props> = ({ className = '', label }) => {
  return (
    <div className={`gray700 f7 fw5 ttu ${className}`}>
      {label}
    </div>
  )
}
